<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
    :class="
      !showLocationPermissionModal && !showLocationAccessBlockedModal
        ? 'hide'
        : ''
    "
  >
    <!-- Location permission popup -->
    <generic-modal
      v-if="
        showLocationPermissionModal && !showAlternateLocationPermissionModal
      "
      :height="menuModalDim.height"
      :width="menuModalDim.width"
      :modalClass="menuModalDim.modalClass"
      :mcClass="menuModalDim.mcClass"
      :zIndex="'9999'"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div class="flex-column location-permission-div">
          <i class="jfi-location fs-14 color-dark-green"></i>
          <p class="fs-14 tc">
            Allow <b class="bold">{{ applicationName }}</b> to access this
            <br />
            device's location ?
          </p>
          <div class="disp-col-inline jcsb full mt20">
            <span
              class="text-cta"
              @click="handleLocationPermissionModal(false)"
            >
              Ask Later
            </span>
            <button
              class="btn medium secondary"
              @click="handleLocationPermissionModal(true)"
            >
              Allow
            </button>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
    <location-access-blocked-message />
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import LocationAccessBlockedMessage from "./LocationAccessBlockedMessage.vue";
import GenericModal from "./GenericModal.vue";
import { clientPlatform, shouldLoginFlowSkip } from "../config/apiEndpoints";
import {
  EVENT_ALLOW_LOCATION_POPUP_VIEW,
  EVENT_ALLOW_LOCATION_POPUP_ACTION,
} from "../helpers/analyticsEvents";

export default {
  name: "AskLocation",
  props: {
    moduleProps: { required: false },
    considerIPLocationToSetStoreInCaseAskLater: {
      required: false,
      default: false,
    },
  },
  components: { GenericModal, LocationAccessBlockedMessage },
  data() {
    return {
      showLocationPermissionModal: false,
      menuModalDim: {
        width: "270px",
        height: "fit-content",
        modalClass: "top-40per",
        mcClass: "ask-loc",
      },
      sessionDependedMethodsProcessed: false,
    };
  },
  mounted() {},
  methods: {
    locationCalls() {
      // if (window.location.href.includes(Utility.getCurrentStoreFolder())) {
      let payload = LocalStorageFunc.getCoordsFromRecentLocation();
      if (payload) {
        payload.source = LocalStorageFunc.getLocationSource();
      }
      if (
        LocalStorageFunc.getDeliveryType() != "D" &&
        LocalStorageFunc.getCoordsForTakeaway()
      ) {
        this.$store.dispatch(
          keyMapsAction.GEO_CODE_API_COMBO,
          LocalStorageFunc.getCoordsForTakeaway()
        );
      } else if (payload?.source == "ip") {
        if (LocalStorageFunc.getHideLocationPopupOnceFromSession()) {
          this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
          LocalStorageFunc.unsetSessionStorageKey("hideLocationPopupOnce");
        } else {
          if (!this.showAlternateLocationPermissionModal) {
            this.showLocationPermissionModal = true;
          }
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL,
            true
          );
          if (!LocalStorageFunc.getIsLocationPermisssionGiven()) {
            this.handleLocationPermissionModal(true);
          } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
            this.handleLocationPermissionModal(false);
          }
        }
      } else if (
        payload?.coords?.latitude
        // &&
        // LocalStorageFunc.isLocationSelectedFromPwaV2()
      ) {
        this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, payload);
      } else {
        if (!this.showAlternateLocationPermissionModal) {
          this.showLocationPermissionModal = true;
        }

        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL,
          true
        );
        if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
          this.handleLocationPermissionModal(true);
        } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
          this.handleLocationPermissionModal(false);
        }
      }
      // } else {
      //   // window.location.href =
      //   //   projectBasePathWithFolder +
      //   //   Utility.getCurrentStoreFolder() +
      //   //   LocalStorageFunc.storeId() +
      //   //   Utility.getUrlQueryString();
      // }
    },
    startupApiCalls() {
      /*       if (this.checkShowLoginModal()) {
        return;
      } */
      const coords = LocalStorageFunc.getCoordsFromRecentLocation();
      if (Utility.isStoreUrlCacheEligible() && coords?.storeId) {
        this.$store.commit(keyMapsMutation.UPDATE_IS_LOCATION_SETTLED, {});
        // this.$store.dispatch(keyMapsAction.UPDATE_CACHED_STORE_DATA, coords);
      } else {
        this.locationCalls();
      }
    },
    startupApiCallsWrapper(PContext, inputFunc) {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(function (PermissionStatus) {
            if (PermissionStatus.state == "granted") {
              LocalStorageFunc.setIsLocationPermissionGiven();
              PContext.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                true
              );
              //console.log("allowed")
            } else if (PermissionStatus.state == "prompt") {
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
              PContext.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                false
              );
              //console.log("prompt");
            } else {
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
              PContext.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                false
              );
              //console.log("denied");
            }
            inputFunc();
          });
      } else {
        inputFunc();
      }
    },
    handleLocationPermissionModal(value) {
      this.showLocationLoadingPopup = true;
      if (value) {
        this.$store.dispatch(keyMapsAction.DETECT_GEO_LOCATION_POPUP, {
          source: "locationPopup",
          showModalM: () => this.showModalM(),
        });
        EVENT_ALLOW_LOCATION_POPUP_VIEW({});
      } else {
        LocalStorageFunc.setAskLocationLaterInSession();
        this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {
          considerIPLocationToSetStore:
            this.considerIPLocationToSetStoreInCaseAskLater,
        });
        setTimeout(() => {
          if (!LocalStorageFunc.getIsLocationPermisssionGiven()) {
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
              true
            );
          }
        }, 5000);
      }
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL,
        false
      );
      this.showLocationPermissionModal = false;
    },
    showModalM() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        true
      );
    },
  },
  computed: {
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.startupApiCallsWrapper(this, () => {
          if (
            !LocalStorageFunc.isLoggedIn() &&
            !LocalStorageFunc.getSessionStorageKey("LOGIN_FLOW_SKIP", "") &&
            !shouldLoginFlowSkip &&
            clientPlatform !== "Web"
          ) {
            Utility.sendToLoginScreen();
          } else {
            if (!LocalStorageFunc.accessToken()) {
              this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {
                startupApiCalls: () => {
                  this.startupApiCalls();
                },
              });
            } else {
              if (!this.isOnLocationPage) {
                this.startupApiCalls();
              }
            }
          }
        });
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
    isOnLocationPage() {
      return Utility.isCurrentlyAtUrl("/location");
    },
    applicationName() {
      return window?._siteProps_?.props?.applicationName
        ? window?._siteProps_?.props?.applicationName
        : "";
    },
    showLocationAccessBlockedModal() {
      return this.$store.state.Location.showLocationAccessBlockedModal;
    },
    showAlternateLocationPermissionModal() {
      return this.$store.state.Location.showAlternateLocationPermissionModal;
    },
  },
};
</script>

<style></style>
